module.exports = __webpack_public_path__ + "img/logo_blue_2.2553c6f4.png";